import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import PropTypes from 'prop-types';

import useColorPalette, { COLOR_MODE } from '../../hooks/useColorPalette';
import { StyledIcon } from '../styles';

/**
 * MenuItemIcon
 *
 * @param {{
 *  className?: string
 *  colorMode?: number
 *  src: string
 * }} props
 *
 * @returns {import('react').ReactNode}
 */
export default function MenuItemIcon({
  className,
  colorMode = COLOR_MODE.ACTIVE_GROWTH,
  src
}) {
  const size = 20;
  const { activeColor, defaultColor } = useColorPalette(colorMode);

  if (!src) {
    return null;
  }

  return (
    <StyledIcon
      className={className}
      component="span"
    >
      <SharedAsset
        alt=""
        className="default"
        coRGB={defaultColor}
        height={size}
        src={src.startsWith('/s2') ? src : `/s2/icon/${src}`}
        width={size}
      />
      <SharedAsset
        alt=""
        className="active"
        coRGB={activeColor}
        height={size}
        src={src.startsWith('/s2') ? src : `/s2/icon/${src}`}
        width={size}
      />
    </StyledIcon>
  );
}

MenuItemIcon.propTypes = {
  className: PropTypes.string,
  colorMode: PropTypes.number,
  src: PropTypes.string.isRequired
};
